// Generated by CoffeeScript 1.12.6
var _, catalogHelpers, moment, purchaseOrderEnums;

_ = require('lodash');

purchaseOrderEnums = require('../../purchase_order/enums');

moment = require('moment');

catalogHelpers = require('../../catalog/helpers');

exports.isLineItemBeforeAvailabilityCutoff = function(lineItem) {
  var dropoffWindowEnd, hours, minutes, ref, ref1, sameDayAvailabilityCutoff, windowEndHours, windowEndMinutes;
  ref = purchaseOrderEnums.sameDayAvailabilityCutoff, hours = ref.hours, minutes = ref.minutes;
  sameDayAvailabilityCutoff = moment().hours(hours).minutes(minutes);
  ref1 = (function() {
    switch (lineItem.dropoffWindow) {
      case '12am-2am':
        return {
          hours: 2,
          minutes: 0
        };
      case '1am-3am':
        return {
          hours: 3,
          minutes: 0
        };
      case '2am-4am':
        return {
          hours: 4,
          minutes: 0
        };
      case '3am-5am':
        return {
          hours: 5,
          minutes: 0
        };
      case '4am-6am':
        return {
          hours: 6,
          minutes: 0
        };
      case '5am-7am':
        return {
          hours: 7,
          minutes: 0
        };
      case '6am-8am':
        return {
          hours: 8,
          minutes: 0
        };
      case '7am-9am':
        return {
          hours: 9,
          minutes: 0
        };
      case '8am-10am':
        return {
          hours: 10,
          minutes: 0
        };
      case '9am-11am':
        return {
          hours: 11,
          minutes: 0
        };
      case '10am-12pm':
        return {
          hours: 12,
          minutes: 0
        };
      case '11am-1pm':
        return {
          hours: 13,
          minutes: 0
        };
      case '12pm-2pm':
        return {
          hours: 14,
          minutes: 0
        };
      case '1pm-3pm':
        return {
          hours: 15,
          minutes: 0
        };
      case '2pm-4pm':
        return {
          hours: 16,
          minutes: 0
        };
      case '3pm-5pm':
        return {
          hours: 17,
          minutes: 0
        };
      case '4pm-6pm':
        return {
          hours: 18,
          minutes: 0
        };
      case '5pm-7pm':
        return {
          hours: 19,
          minutes: 0
        };
      case '6pm-8pm':
        return {
          hours: 20,
          minutes: 0
        };
      case '7pm-9pm':
        return {
          hours: 21,
          minutes: 0
        };
      case '8pm-10pm':
        return {
          hours: 22,
          minutes: 0
        };
      case '9pm-11pm':
        return {
          hours: 23,
          minutes: 0
        };
      case '10pm-12am':
        return {
          hours: 23,
          minutes: 59
        };
      default:
        return {
          hours: 23,
          minutes: 59
        };
    }
  })(), windowEndHours = ref1.hours, windowEndMinutes = ref1.minutes;
  dropoffWindowEnd = moment().hours(windowEndHours).minutes(windowEndMinutes);
  return dropoffWindowEnd.isBefore(sameDayAvailabilityCutoff);
};

exports.convertQuantityToCatalogUnits = function(lineItem, quantityAttribute, catalogProduct) {
  return catalogHelpers.unitConverter(catalogProduct).convertTo(lineItem[quantityAttribute], 'orderQuantity');
};
